import React, { FunctionComponent, CSSProperties } from 'react';

type Props = {
  backgroundStyle: CSSProperties;
};

export const Presentation: FunctionComponent<Props> = ({
  backgroundStyle,
}) => {
  return (
    <div className="company-info-page-top mt">
      <div className="company-info-page-top-img" style={backgroundStyle} />
    </div>
  );
};
